<section class="link-options-wrapper">
    <app-confirm-popup *ngIf="showModal" [title]="'Delete'" [message]="'Are you sure you want to delete the selected Lot(s) ?'"
        [confirmText]="'Delete'" [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="onDeleteConfirm()"
        (cancel)="onDeleteCancel()"></app-confirm-popup>
    <div class="link-options-block mt-3 row mb-2">
        <div class="col-md-6 mb-2 d-flex flex-column custom-select-v2">
            <label class="form-label">Search Lot From Parent</label>
            <nz-select nzShowSearch="true" nzMode="multiple" #multiSelectLotRef="nzSelect" [(ngModel)]="lotValues"
                nzAllowClear="true" nzPlaceHolder="Select Lots" nzSize="default" [nzDropdownRender]="dropDownRender">
                @for(lot of lotList.availableLots;track lot.lotId){
                <nz-option [nzValue]="lot" [nzLabel]="lot.lotId+'-'+lot.lotDesc"></nz-option>
                }
            </nz-select>
            <ng-template #dropDownRender>

                <div class="d-flex justify-content-end p-2">
                    <button nz-button nzType="primary" class="ok-btn" (click)="closeSelect(multiSelectLotRef)">
                        Ok
                    </button>
                </div>

            </ng-template>
            <span class="text-danger" *ngIf="lotValues.length == 0 && validateValues">
                Lot value is required.
            </span>
        </div>
        <div class="col-md-6 mb-2 d-flex flex-column custom-select-v2">
            <label class="form-label">Search Lot From Other</label>
            <nz-select [nzNotFoundContent]="otherLotSearched && otherLotList.length == 0 ? emptyTpl : searchLotTpl  " nzShowSearch="true" nzMode="multiple"
                #multiSelectOtherLotRef="nzSelect" [(ngModel)]="otherLotValues" nzAllowClear="true"
                nzPlaceHolder="Select Lots" nzSize="default" (nzOnSearch)="getOtherLotList($event)"
                [nzDropdownRender]="dropDownOtherRender" (nzOpenChange)="resetSearch($event)" >
                @for(lot of otherLotList;track lot.lotId){
                <nz-option [nzDisabled]="lot?.disabled" [nzValue]="lot"
                    [nzLabel]="lot.lotId+'-'+lot.lotDesc"></nz-option>
                }
            </nz-select>
            <span class="text-danger" *ngIf="otherLotValues.length == 0 && validateValues">
                Lot value is required.
            </span>
            <ng-template #dropDownOtherRender>
                <div class="d-flex justify-content-end p-2">
                    <button nz-button nzType="primary" class="ok-btn"
                        (click)="closeOtherSelect(multiSelectOtherLotRef)">
                        Ok
                    </button>
                </div>

            </ng-template>
            <ng-template #searchLotTpl>
                <div style="text-align: center; padding: 20px;">
                    <span nz-icon nzType="search" class="search-icon"></span>
                    <p style="margin-top: 8px; color: #8c8c8c;">Search For a Lot.</p>
                </div>
            </ng-template>
            <ng-template #emptyTpl>
                <nz-empty nzNotFoundImage="simple"></nz-empty>
            </ng-template>
        </div>
        <div class="col-md-12 d-flex flex-row mb-2 justify-content-end">
            <button (click)="resetForm()" nz-button nzType="default">Reset</button>
            &nbsp;
            <button nz-button nzType="primary" (click)="saveLot()" class="d-flex align-items-center"
                [nzSize]="'default'"><span nz-icon nzType="plus"></span>Add</button>
        </div>
    </div>
    <div class="associate-wrapper px-3">
        <div class="link-options-list p-2">
            <div class="link-option-header px-4 d-flex justify-content-between align-items-center">
                <label>Association Lots</label>
                <button nz-button nzType="primary" [disabled]="selectedIds.size == 0"
                    (click)="deAssociate()">DeAssociate</button>
            </div>
            <div class="col-md-6 px-4 mt-2">
                <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;" nzSize="default"
                    [nzSuffix]="suffixIconSearch">
                    <input type="text" class="py-1" nz-input placeholder="Search For Lot #"
                        (keydown.enter)="searchLot(SearchText.value)" [(ngModel)]="searchText" nzAllowClear
                        #SearchText />
                    <span class="close-icon" (click)="SearchText.value = '';searchLot('')" class="px-1" nz-icon
                        nzType="close-circle"></span>

                </nz-input-group>
                <ng-template #suffixIconSearch>
                    <span class="search-icon" (click)="searchLot(SearchText.value)" nz-icon nzType="search"></span>
                </ng-template>
            </div>
            @if(lotList.associatedLots){
            <ng-container>
                <app-data-grid [columns]="table_fields" [dataSet]="lotList.associatedLots" [gridStyle]="'white'"
                    (deleteRow)="deleteRow($event)" (updateRow)="updateRow($event)"
                    (selectedRows)="selectedRows($event)"></app-data-grid>
            </ng-container>
            }
        </div>
    </div>
</section>